export const APP = 'APP';
export const PROFILE = 'PROFILE';
export const THEME = 'THEME';
export const MODULE = 'MODULE';
export const ASSET = 'ASSET';
export const ACADEMY = 'ACADEMY';